import personalDetailsRouteInfo from '../../tabs/PersonalDetails/routes/routeInfo';
import { PERSONAL_DETAILS_PATH } from '../../tabs/PersonalDetails/routes/routePaths';
import financingTermsRouteInfo from '../../tabs/FinancingTerms/routes/routeInfo';
import { FINANCING_TERMS_PATH } from '../../tabs/FinancingTerms/routes/routePaths';
import notificationSettingsRouteInfo from '../../tabs/NotificationSettings/routes/routeInfo';
import { NOTIFICATION_SETTINGS_PATH } from '../../tabs/NotificationSettings/routes/routePaths';
import privacySettingsRouteInfo from '../../tabs/PrivacySettings/routes/routeInfo';
import { PRIVACY_SETTINGS_PATH } from '../../tabs/PrivacySettings/routes/routePaths';
import referralsRouteInfo from '../../tabs/Referrals/routes/routeInfo';
import { REFERRALS_PATH } from '../../tabs/Referrals/routes/routePaths';

export const navigationTabs = [
  personalDetailsRouteInfo[PERSONAL_DETAILS_PATH],
  financingTermsRouteInfo[FINANCING_TERMS_PATH],
  notificationSettingsRouteInfo[NOTIFICATION_SETTINGS_PATH],
  privacySettingsRouteInfo[PRIVACY_SETTINGS_PATH],
  referralsRouteInfo[REFERRALS_PATH]
];

export default navigationTabs;
